<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="container">

          <div style="text-align: left">
            <div><span style="color:#606266">流程ID：</span>{{ item.FlowName }}</div>
            <div><span style="color:#606266">业务人员：</span>{{ item.UserName }}</div>
            <div><span style="color:#606266">邮箱：</span>{{ item.MailAddress }}</div>
            <div><span style="color:#606266">机器人：</span> {{ item.Abbr }}</div>
            <div><span style="color:#606266">创建时间：</span>{{ item.CreationTime }}</div>

          </div>
          <div>
            <van-button :disabled="checkdisabled(item)" type="success" size="small" @click="stopProcess(item)">取消排队
            </van-button>
          </div>
        </div>
      </van-cell>
    </van-list>
  </van-pull-refresh>
</template>

<script>

import {defineComponent, ref} from "vue";
import {List, Cell, Button, showConfirmDialog, Notify, showNotify, PullRefresh,} from 'vant'
import 'vant/lib/index.css'
import Qs from "qs";


export default {
  name: "QueueList",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [PullRefresh.name]: PullRefresh
  },
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(50)
    const totalResult = ref(0) //总数量
    const refreshing = ref(false);
    return {
      list,
      loading,
      finished,
      currentPage,
      pageSize,
      totalResult,
      refreshing

    }
  },
  methods: {
    stopProcess(row) {
      showConfirmDialog({
        title: '提示',
        message:
          '您确定要取消排队吗？',
      })
        .then(() => {
          const params = {
            'uid': this.$store.state.userID,
            'email': this.$store.state.email,
            'actionType': '1',
            'actionKey': [row.Id, row.FlowName, this.$store.state.userName]
          };
          this.$api.jobManageAPI.delQueueItem(Qs.stringify(params))
            .then(res => {
              if (res.data.Success == false) {
                showNotify({type: 'danger', message: res.data.Message});
                return;
              }
              showNotify({type: 'success', message: '排队取消成功'});

              // console.log(res.data.Data);
              this.findData();

            })
            .catch(error => {
              console.log(error);

            })
        })
        .catch(() => {
          // on cancel
        });
    },
    loadData() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false;
      }
      if (this.totalResult === 0 || this.list.length === 0) {
        this.currentPage = 1;
      } else {
        if (this.currentPage < Math.ceil(this.totalResult / this.pageSize)) {
          this.currentPage++
        }
      }

      // 模拟异步加载数据
      this.loading = true;
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.currentPage,
        'pageSize': this.pageSize,
        'searchKey': ['']
      };
      this.$api.jobManageAPI.getQueueList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            showNotify({type: 'danger', message: res.data.Message});
            return;
          }
          this.totalResult = res.data.Data.totalResult;
          this.list = [];
          for (const row of res.data.Data.dataTable) {
            if (row.UserName === null || row.UserName == '') {
              continue;
            }
            this.list.push({
              'Id': row.Id,
              'MachineName': row.MachineName,
              'Abbr': row.Abbr,
              'FlowName': row.FlowName,
              'UserName': row.UserName,
              'MailAddress': row.MailAddress,
              'leve': row.leve,
              'CreationTime': row.CreationTime
            })
          }

          this.finished = true;

          this.isLoading = false;

        })
        .catch(error => {
          console.log(error);

        })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.loadData();
    },
    checkdisabled(row) {
      if (row.FlowName == null || row.FlowName == '') {
        return true
      }
      if (this.$store.state.isAdmin == '1') {
        return false
      }
      if (this.$store.state.email == row.MailAddress) {
        return false
      }
      return true
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
